export default {
  methods: {
    getSymbolImage(symbol) {
      let name = symbol.toLowerCase();
      let image = require.context("@/app/assets/imagens/", false, /\.jpg$/);
      return image("./" + name + ".jpg");
    },
  },
};
